import React from "react";
import { Link } from "react-router-dom";
import { CreditCard, CalendarClock, BadgeCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

const PLAN_LABEL = { free: "Free", pro: "Pro Host", pm: "Property Manager" };

const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" }) : null);

export const SubscriptionCard = ({ subscription }) => {
  const s = subscription || {};
  const nextBilling = fmtDate(s.next_billing_date);
  const endsOn = fmtDate(s.current_period_end);
  return (
    <div className="rounded-xl border bg-card p-5" data-testid="dashboard-subscription-card">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <CreditCard className="h-4 w-4 text-primary" />
          <h3 className="font-display text-base font-semibold">Subscription</h3>
        </div>
        <Badge className="bg-primary/10 text-primary" data-testid="subscription-plan-badge">{PLAN_LABEL[s.plan] || "Free"}</Badge>
      </div>
      <div className="mt-4 space-y-2.5 text-sm">
        <div className="flex items-center justify-between">
          <span className="text-muted-foreground">Status</span>
          <span className="flex items-center gap-1 font-medium capitalize">
            <BadgeCheck className="h-3.5 w-3.5 text-[hsl(var(--risk-low))]" />{s.status || "active"}
          </span>
        </div>
        {s.cancel_at_period_end ? (
          <div className="flex items-center justify-between">
            <span className="text-muted-foreground">Active until</span>
            <span className="flex items-center gap-1 font-medium"><CalendarClock className="h-3.5 w-3.5" />{endsOn || "—"}</span>
          </div>
        ) : nextBilling ? (
          <div className="flex items-center justify-between">
            <span className="text-muted-foreground">Next billing date</span>
            <span className="flex items-center gap-1 font-medium" data-testid="next-billing-date"><CalendarClock className="h-3.5 w-3.5" />{nextBilling}</span>
          </div>
        ) : null}
      </div>
      <div className="mt-4 flex gap-2">
        <Link to="/app/billing" className="flex-1"><Button variant="outline" size="sm" className="w-full" data-testid="dashboard-manage-billing">Manage billing</Button></Link>
      </div>
    </div>
  );
};
